import { useTranslation } from "react-i18next";

const STATUS_KEYS = {
  good: "success",
  okay: "warning",
  poor: "poor",
  critical: "critical",
  "under-repair": "warning",
  queue: "poor",
  ready: "success",
  "external-repair": "warning",
  open: "warning",
  "in-shop": "warning",
  inspection: "warning",
  "in-progress": "poor",
  completed: "success",
  "waiting-parts": "poor",
  closed: "success",
  pending: "warning",
  "3": "success",
  "2": "poor",
  "1": "critical",
  failed: "critical",
  completed: "success",
  pending: "warning",
  review: "poor",
  "tasks-completed": "success"
};

export const GetVehicleCondition = ({ condition }) => {
  const { t } = useTranslation();
  return (
    <span className={STATUS_KEYS[condition?.toLowerCase()] || ""}>
      {t(`statuses.${condition?.toLowerCase()}`)}
    </span>
  )
};

export const GetMaintenanceStatus = ({ status }) => {
  const { t } = useTranslation();
  if (status !== "closed") {
    return (
      <span className="warning">
        {t(`forms.type.maintenance-report.status-options.${status}`)}
      </span>
    );
  } else {
    return (
      <span className="">
        {t(`forms.type.maintenance-report.status-options.${status}`)}
      </span>
    );
  }
};
